import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/user-state-settings')
export class UserStateSettingsDto extends DtoHasApi {
  key: string;
  value: any;
}
